/**
 * Convert an array of flat objects to a CSV string.
 * Handles values containing commas, quotes, and newlines.
 */
export function objectToCSV(rows) {
  if (!rows || rows.length === 0) return "";

  const headers = Object.keys(rows[0]);
  const escapeField = (value) => {
    let str = value === null || value === undefined ? "" : String(value);
    // Neutralize spreadsheet formula prefixes to prevent CSV injection
    if (/^[=+\-@\t\r]/.test(str)) {
      str = "'" + str;
    }
    if (str.includes(",") || str.includes('"') || str.includes("\n")) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  const headerLine = headers.map(escapeField).join(",");
  const dataLines = rows.map((row) =>
    headers.map((h) => escapeField(row[h])).join(",")
  );

  return [headerLine, ...dataLines].join("\n");
}

/**
 * Trigger a browser file download from a CSV string.
 */
export function downloadCSV(csvString, filename) {
  const blob = new Blob([csvString], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
